import { useJourneyStore } from '@/store/journeyStore'
import { useJourneyAction } from '@/lib/journeyActions'

/** "Next step: … [action]" — repeated on every tab except Next step. */
export default function NextStepStrip() {
  const journey = useJourneyStore((s) => s.journey)
  const run = useJourneyAction()
  const next = journey?.next
  if (!next || !next.title) return null
  return (
    <div className="swb-strip" role="status">
      <span className="swb-eyebrow">Next step</span>
      <span className="swb-strip-title">{next.title}</span>
      {next.primary && (
        <button type="button" className="swb-btn swb-btn-primary" onClick={() => void run(next.primary!.action)}>
          {next.primary.label}
        </button>
      )}
    </div>
  )
}
